export default __webpack_public_path__ + "static/media/backer-newfieldfund.4340cbc4.png";